export const getRecipe = async (id: string) => {
  const response = await fetch(`/api/recipes/${id}`);
  return await response.json();
};
